module.exports = __webpack_public_path__ + "static/media/LU.c8fa574d.png";